const URL = window.location.hostname === `localhost`
			? `http://localhost:3030/server`
			: `/server`
export { URL }

